<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    <path d="M17.58,13.29a4.82,4.82,0,0,1,1.94-3.87.5.5,0,0,0,.07-.72A5.16,5.16,0,0,0,16,7h0c-1.69-.16-3.3,1-4.16,1S9.58,7,8.18,7A5.34,5.34,0,0,0,3.67,9.76C1.75,13.1,3.18,18,5,20.74c.91,1.32,2,2.81,3.44,2.76s1.9-.89,3.57-.89,2.14.89,3.6.86S18.08,22.12,19,20.8a12.23,12.23,0,0,0,1.37-2.67.5.5,0,0,0-.23-.61A4.76,4.76,0,0,1,17.58,13.29Z"/><path d="M15,4.17a5.24,5.24,0,0,0,1.22-3.09.5.5,0,0,0-.6-.51,5.35,5.35,0,0,0-2.81,1.67,5.07,5.07,0,0,0-1.25,3,.5.5,0,0,0,.55.51A4.48,4.48,0,0,0,15,4.17Z"/>
  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'os-system-apple',
    },
    name: {
      type: String,
      required: false,
      default: 'OsSystemApple',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>